import { render, staticRenderFns } from "./Bunches.vue?vue&type=template&id=3e7aedd9&scoped=true&"
import script from "./Bunches.vue?vue&type=script&lang=js&"
export * from "./Bunches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7aedd9",
  null
  
)

export default component.exports